module.exports = typeof require;


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/typeof/typeof.js
 ** module id = 1
 ** module chunks = 0
 **/